/*
 * @Descripttion: 复制
 * @Date: 2025-02-28 11:40:57
 */
import { XrkMessage } from 'xrk-components';
// 兼容旧浏览器的回退方案;
function legacyCopy(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  XrkMessage.success('复制成功');
}

export async function useCopy(text) {
  const isSupported = navigator && 'clipboard' in navigator;
  try {
    if (isSupported) {
      await navigator.clipboard.writeText(text);
      XrkMessage.success('复制成功');
    } else {
      legacyCopy(text);
    }
  } catch (error) {
    XrkMessage.error('复制失败');
  }
}
